export class Authority {
  id: number;
  module: number;
  onlySuperadmin: number;
  code: string;
  description: string;
  createAt: string;
  active: number;
}
